import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from './authSlice';

export interface OnboardingState {
    role: string;
    companyWebsite: string;
    socials: {
        linkedin: string;
        twitter: string;
    };
    referralSource: string;
    currentStep: number;
}

const initialState: OnboardingState = {
    role: '',
    companyWebsite: '',
    socials: {
        linkedin: '',
        twitter: '',
    },
    referralSource: '',
    currentStep: 1,
};

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        setRole(state, action: PayloadAction<string>) {
            state.role = action.payload;
        },
        setCompanyWebsite(state, action: PayloadAction<string>) {
            state.companyWebsite = action.payload;
        },
        setSocials(state, action: PayloadAction<{ linkedin?: string; twitter?: string }>) {
            state.socials = { ...state.socials, ...action.payload };
        },
        setReferralSource(state, action: PayloadAction<string>) {
            state.referralSource = action.payload;
        },
        setCurrentStep(state, action: PayloadAction<number>) {
            state.currentStep = action.payload;
        },
        resetOnboarding(state) {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => initialState);
    },
});

export const {
    setRole,
    setCompanyWebsite,
    setSocials,
    setReferralSource,
    setCurrentStep,
    resetOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
